/**
 * @typedef {Object} Project
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} longDescription
 * @property {string[]} tags
 * @property {string} link
 * @property {boolean} featured
 */

/**
 * @typedef {Object} Experience
 * @property {string} id
 * @property {string} role
 * @property {string} company
 * @property {string} period
 * @property {string} description
 */

export const PORTFOLIO_DATA = {
  personal: {
    name: "David",
    company: "Solopreneur Solutions",
    role: "Founder & AI Architect",
    tagline: "Democratizing AI for the Solo Developer",
    shortBio: "After 15 years in enterprise tech, I founded Solopreneur Solutions to help outmanned indie developers punch above their weight class.",
    about: "For 15 years, I climbed the corporate ladder, building scalable architectures for Fortune 500s. Then, a massive merger happened. The bureaucracy doubled, the innovation halved. I realized my true passion wasn't in endless meetings, but in building tools that empower creators. I took the leap into the indie world and founded Solopreneur Solutions. My mission is to help outmanned indie developers punch above their weight class by making Artificial Intelligence accessible, relatable, and highly actionable. I believe AI is the ultimate force multiplier for the underdog."
  },
  projects: [
    {
      id: "solopreneur-os",
      title: "Solopreneur OS",
      description: "The complete operating system for indie developers to manage their entire business.",
      longDescription: "A comprehensive dashboard integrating task management, financial tracking, and marketing automation specifically tailored for the solo developer context. Built with React and AI-driven insights to predict burnout and optimize work schedules.",
      tags: ["React", "AI Integration", "Productivity"],
      link: "https://solopreneur.solutions",
      featured: true
    },
    {
      id: "project-alpha",
      title: "Project Alpha",
      description: "Ideation and validation app to put hard data behind your app decisions.",
      longDescription: "Stop guessing what people want. Project Alpha uses LLMs to analyze market trends, scrape competitor data, and validate your indie app ideas before you write a single line of code.",
      tags: ["Data Analytics", "LLM", "Market Research"],
      link: "#",
      featured: true
    },
    {
      id: "protocol-100",
      title: "Protocol100",
      description: "Take your idea from 0 to shipped indie developer in exactly 100 days.",
      longDescription: "An interactive, AI-guided curriculum that holds you accountable. It breaks down the daunting task of launching a SaaS into 100 daily, actionable micro-tasks.",
      tags: ["Education", "Gamification", "Community"],
      link: "https://protocol100.xyz",
      featured: true
    },
    {
      id: "legacy-corp-tool",
      title: "Enterprise Migrator",
      description: "A tool born from my corporate days, helping transition legacy databases.",
      longDescription: "While I focus on indie tools now, this project pays the bills. It safely migrates massive monolithic databases into modern, serverless architectures.",
      tags: ["DevOps", "Database", "Legacy"],
      link: "#",
      featured: false
    }
  ],
  experience: [
    {
      id: "exp-1",
      role: "Founder",
      company: "Solopreneur Solutions",
      period: "2025 - Present",
      description: "Bootstrapping a portfolio of AI-first SaaS products for developers."
    },
    {
      id: "exp-2",
      role: "Principal Software Engineer",
      company: "United Health Group",
      period: "2018 - 2023",
      description: "Led the architectural integration during the $5B merger. Managed a team of 40 engineers across 3 continents."
    },
    {
      id: "exp-3",
      role: "Senior Backend Engineer",
      company: "CBH",
      period: "2012 - 2018",
      description: "Architected distributed systems handling millions of transactions daily."
    },
    {
      id: "exp-4",
      role: "Software Developer",
      company: "Various Startups",
      period: "2008 - 2012",
      description: "Cut my teeth building early web applications and scaling relational databases."
    }
  ]
};